import { type BreadcrumbsProps, Breadcrumbs } from '..';
import { LinkRouter, type LinkRouterProps } from '../../link/link-router';
import { Typography } from '../../typography';

export interface BreadcrumbsRouterProps
  extends Omit<BreadcrumbsProps, 'children'> {
  crumbs: { label: string; to: LinkRouterProps['to'] }[];
}

export const BreadcrumbsRouter = ({
  crumbs,
  ...rest
}: BreadcrumbsRouterProps) => (
  <Breadcrumbs {...rest}>
    {crumbs.map(({ label, to }, index) => {
      const last = index === crumbs.length - 1;

      return last ? (
        <Typography key={label} color="textPrimary" variant="body2">
          {label}
        </Typography>
      ) : (
        <LinkRouter underline="hover" to={to} key={label} variant="body2">
          {label}
        </LinkRouter>
      );
    })}
  </Breadcrumbs>
);
